// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate from 'vee-validate';
import colors from 'vuetify/es5/util/colors';
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
//import 'vuetify/src/stylus/main' // Ensure you are using stylus-loader
import Truncate from 'lodash.truncate';
import store from './store';
//import Sortable from 'sortablejs';

//import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

// global components
import GlobalComponents from './globalComponents'
import moment from 'moment'

import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'
import VueHotkey from 'v-hotkey'
Vue.use(VueHotkey)
//Vue.use(Sortable)
//Vue.component('tiny-mce', TinyMCE);

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import VueCkeditor from 'vue-ckeditor5'

import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)


// editor 
import 'tui-editor/dist/tui-editor.css';
import 'tui-editor/dist/tui-editor-contents.css';
import 'codemirror/lib/codemirror.css';


const options = {
  editors: {
    classic: ClassicEditor,
  },
  name: 'ckeditor'
}
Vue.prototype.$eventHub = new Vue(); // Global event bus
Vue.use(VueCkeditor.plugin, options);

Vue.use(DatetimePicker)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format('DD-MMM-YYYY')
  }
});
Vue.filter('format_date', function fmt(date = '') {
  let date_parts = date.match(/^(\d{4})-(\d+)-(\d+)(.*)$/);
  let year;
  let month;
  let day;

  if (date_parts) {
    year = ('00' + date_parts[1]).slice(-4);
    month = ('0' + date_parts[2]).slice(-2);
    day = ('0' + date_parts[3]).slice(-2);

    return month + '-' + day + '-' + year + date_parts[4];
  } else {
    return date;
  }
});

Vue.config.productionTip = false;

Vue.filter('uppercase', function (value) {
  return value.toUpperCase()
})
// Helpers
// Global filters
Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, {
  fieldsBagName: 'formFields'
});
Vue.use(GlobalComponents);
Vue.use(colors);
Vue.use(Vuetify, {
  // theme: {
  //   primary: colors.indigo.base, // #E53935
  //   secondary: colors.indigo.lighten4, // #FFCDD2
  //   accent: colors.indigo.base // #3F51B5
  // },
  iconfont: 'mdi' || 'fa' || 'md',


  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    }
  }
});
// Bootstrap application components



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js